import React, { forwardRef } from 'react';
import { Box } from '@fiverr-private/theme';
import { border } from '../shared';
import { CardProps } from '../types';

const Card = forwardRef<HTMLElement, CardProps>(({ children, borderRadius = 'sm', ...restProps }: CardProps, ref) => (
  <Box ref={ref} {...border} borderRadius={borderRadius} {...restProps}>
    {children}
  </Box>
));

Card.displayName = 'Card';

export default Card;
